<template>
  <div>
    <loading v-if="isLoading" />
    <BFormGroup
      v-if="!isLoading"
      :label="label">
      <BFormCheckboxGroup
        v-model="valor"
        :options="opcoes"
        stacked />
    </BFormGroup>
  </div>
</template>

<script>
import { BFormGroup, BFormCheckboxGroup } from 'bootstrap-vue/es/components'
import loading from '@/components/loading/loading.vue'
import InputBaseMixins from './mixins/InputBaseMixins'
import ServicoService from '../../services/servicos.service'

export default {
  name: 'InputCheckServicos',
  mixins: [InputBaseMixins],
  components: {
    BFormGroup,
    BFormCheckboxGroup,
    loading,
  },
  data() {
    return {
      isLoading: false,
      opcoes: [],
    }
  },
  beforeMount() {
    this.carregaTudo()
  },
  methods: {
    async carregaTudo() {
      try {
        this.isLoading = true
        const servicos = await ServicoService.retornaTodos()
        this.opcoes = this.formataDados(servicos.lista)
      } catch (error) {
        this.opcoes = []
      } finally {
        this.isLoading = false
      }
    },
    formataDados(itens) {
      const retorno = itens.map(item => (
        {
          text: item.descricao,
          value: item,
        }
      ))

      return retorno
    },
  },
}

</script>

<style lang="scss">
.custom-control-label {
  cursor: pointer;
}

</style>
